commonModule.factory('$exceptionHandler', ['$injector', function($injector) {
        return function(exception) {
            var err = null;
            var tlcError = null;

            if (exception.hasOwnProperty('originalError')) {
                tlcError = exception;
                err = tlcError.originalError;
            }else{
                err = exception;
            }
            var $rootScope = $injector.get('$rootScope');
            var growl = $injector.get('growl');
            var errorMessageLookupService = $injector.get('errorMessageLookupService');
            var errorStackService = $injector.get('stacktraceBuilderService');

            if (tlcError) {
                if (tlcError.showConsoleErr) {
                    console.log(err);

                    if (errorStackService){
                        try {
                            errorStackService.getSourceMappedStackTrace(err)
                            .then(
                                function gotStackFrames(stackFrames) {
                                    console.log(JSON.stringify(stackFrames));
                                },
                                function (errNoFrames) {
                                    console.log(JSON.stringify(err.stack));
                                }
                            ).catch(
                                function(err){
                                    var x = err;//ignore
                                }
                            );
                        }catch(e){
                            var x = e;//ignore
                        }//do nothing with errors from stacktrace.js
                    }else{
                        console.log(JSON.stringify(err.stack));
                    }
                }
                errorMessageLookupService.lookupErrorMessage(tlcError.appErrorCode)
                .then(
                    function successFoundMessage(msg) {
                        tlcError.appErrorMsg = msg;
                        if (tlcError.appErrorMsg){
                            growl.error(tlcError.appErrorMsg);
                        }
                    },
                    function errorFoundMessage(err) {
                        tlcError.appErrorMsg = null;
                    }
                );
            }
        }
    }]);
